module.exports = __webpack_public_path__ + "img/index_yuan.b3d53819.png";